
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {Toast} from 'vant';

  import {getNavigationAsync} from '@/api/map';

  @Component({})
  export default class VirtualNavigation extends Vue {
    @Prop({required: true, default: () => false}) private show!: boolean;
    @Prop({default: () => ''}) private roomId!: string;

    private currentShow = this.show;
    private loading = false;
    private point = {
      startName: '',
      startId: '',
      endName: '',
      endId: ''
    };
    private isHasNavigation = false;
    private meter = '';

    private mounted() {
    }

    private handlerToNavigation(item: any) {
      if (!this.point.startName && !this.point.endName) {
        this.point.startName = item.name;
        this.point.startId = item.id;
      } else if (this.point.startName && !this.point.endName && this.point.startId !== item.id) {
        this.point.endName = item.name;
        this.point.endId = item.id;
      }
    }

    private async handlerNavigation() {
      if (!this.point.startId || !this.point.endId) {
        Toast({
          message: '请先选择起点和终点',
          position: 'bottom',
        });
        return false;
      }

      await this.getNavigationLine();
    }

    private async getNavigationLine() {
      if (this.point.startId && this.point.endId && this.roomId) {
        this.loading = true;
        const result = await getNavigationAsync(this.roomId, this.point.startId, this.point.endId);
        this.loading = false;
        if (result) {
          this.isHasNavigation = true;
          this.meter = result.meter;
          if (result.points.length > 0) {
            this.$emit('getLines', result.points);
          }
        }
      }
    }

    private resetPoint() {
      this.point.startName = '';
      this.point.startId = '';
      this.point.endName = '';
      this.point.endId = '';
    }

    private handlerClose() {
      this.resetPoint();
      this.$emit('close', false);
    }
  }
